import { render, staticRenderFns } from "./TodoItem.vue?vue&type=template&id=3b6c15c2&scoped=true&lang=pug&"
import script from "./TodoItem.vue?vue&type=script&lang=js&"
export * from "./TodoItem.vue?vue&type=script&lang=js&"
import style0 from "./TodoItem.vue?vue&type=style&index=0&id=3b6c15c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c15c2",
  null
  
)

component.options.__file = "TodoItem.vue"
export default component.exports